module.exports = __webpack_public_path__ + "img/gift_card.98aad53c.jpg";